import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useState } from 'react';
import { JsonEditor } from "react-jsondata-editor";
import { useNavigate } from "react-router-dom";
import { errorAlert, successAlert } from '../utils/toastifyAlerts'
import { ToastContainer } from 'react-toastify';
import PostResumeSchemaless from '../helpers/postResumeSchemaless'; 
import GetPersonalUserData from "../helpers/getPersonalUserData.js";
import mock from "../utils/mockData.js"


const ResumeCreator = (state) => {
    const [template, setTemplate] = useState()
    const [templateSelected, setTemplateSelected] = useState('select a template or start from zero')
    const [userInfo, setUserInfo] = useState()
    const navigate = useNavigate();

    // There should fetch templates from db
    const templates = mock.templates
    const titles = Object.keys(mock.templates)

    const setTemplateDataFunc = (title) => {
        setTemplateSelected(templates[title])
    }

    useEffect(() => {
        setTemplate(JSON.stringify(templateSelected))
    }, [templateSelected])

    useEffect(() => {
        const data = setPersonalUserData()
        setUserInfo(data)
    }, [])

    const setPersonalUserData = async () => {
        const data = await GetPersonalUserData()
        setUserInfo(data)
    }

    function saveJsonString(output) {
        if (output === undefined) {
            setTemplate('')
        } else {
            setTemplate(output)
        }
    }

    const saveChanges = async () => {
        if (template!=='select a template or start from zero'){
            try {
                const resp = await PostResumeSchemaless(template, userInfo)
                successAlert(resp.msg)
                setTemplate(JSON.stringify(resp.resume))
            } catch (e) {
                errorAlert(e);
            }
        } else {
            errorAlert('please edit your resume before commit changes');
        }
    }

    const goBack = () => {
        navigate(-1);
    }

    return (
        <div>
            <div className="title re">
                <h3 data-test="title">resume creator</h3>
            </div>
            <div className="mx-3 mt-2 resumeTitle" >
                <Dropdown data-test="templateDropdown">
                    <Dropdown.Toggle variant="Secondary">
                        templates
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {titles && titles.map(
                            (title, index) => (
                                <Dropdown.Item data-test='dropdownItem' key={index} as="button" onClick={() => { setTemplateDataFunc(title) }
                                }>{title}</Dropdown.Item>
                            ),
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            </div >
            <div className='JSONEditorContainer'>
                <div className='JSONEditor'>
                    <JsonEditor jsonObject={template} onChange={(output) => saveJsonString(output)} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <button data-test='save' className="my-3 btnSCV btnSCV-a" onClick={saveChanges}>Save</button>
                        <button data-test='back' className="my-3 btnSCV btnSCV-a" onClick={goBack}>Back</button>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default ResumeCreator